export const INVALID_TOKEN_RESPONSE_MESSAGE = 'Auth0 silent renewal returned an invalid token response';
export const INVALID_TOKEN_RESPONSE_ERROR_CODE = 'invalid_token_response';

export const createInvalidTokenResponseError = () =>
  Object.assign(new Error(INVALID_TOKEN_RESPONSE_MESSAGE), {
    code: INVALID_TOKEN_RESPONSE_ERROR_CODE,
    error: INVALID_TOKEN_RESPONSE_ERROR_CODE,
  });

const decodeBase64Url = (value: string): string => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
  return atob(padded);
};

export const decodeJwtJsonPayload = (accessToken: string): Record<string, unknown> | null => {
  if (!accessToken || typeof accessToken !== 'string') {
    return null;
  }

  const parts = accessToken.split('.');
  if (parts.length !== 3 || !parts[0] || !parts[1] || !parts[2]) {
    return null;
  }

  try {
    const payload = JSON.parse(decodeBase64Url(parts[1]));
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      return null;
    }
    return payload as Record<string, unknown>;
  } catch {
    return null;
  }
};

export const deriveSessionTiming = (accessToken: string, now = Date.now()): { issuedAt: number; expiresAt: number } => {
  const payload = decodeJwtJsonPayload(accessToken);
  const expSeconds = Number(payload?.exp);
  const iatSeconds = Number(payload?.iat);
  if (payload && Number.isFinite(expSeconds) && expSeconds * 1000 > now) {
    return {
      issuedAt: Number.isFinite(iatSeconds) ? iatSeconds * 1000 : now,
      expiresAt: expSeconds * 1000,
    };
  }

  throw createInvalidTokenResponseError();
};
